var _defs, _polygon, _polygon2, _polygon3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnityLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Logo",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .f {\n        fill: #fff;\n      }\n\n      .g {\n        fill: #4d4d4d;\n      }\n\n      .h {\n        fill: gray;\n      }\n\n      .i {\n        fill: #ebebeb;\n      }\n\n      .j {\n        fill: #d9d9d9;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "g",
    points: "499.12 492.21 0 201.94 0 1000 500 1000 499.12 492.21"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "499.12 492.21 1000 200.22 1000 1000 500 1000 499.12 492.21"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "h",
    points: "499.12 492.21 1000 200.22 1000 0 0 0 0 201.94 499.12 492.21"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b",
    "data-name": "g849"
  }, /*#__PURE__*/React.createElement("path", {
    id: "c",
    "data-name": "path8",
    className: "j",
    d: "m499.78,873.92l301.59-174.49-115.29-66.99-118.41,68.55c-4.67,3.12-9.35,0-9.35-6.23v-162.03c0-4.67,3.12-9.35,6.23-10.91l140.22-81.02c4.67-3.12,9.35,0,9.35,6.23v137.1l115.29,66.99v-351.46l-330.29,192.54.66,381.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    "data-name": "path10",
    className: "f",
    d: "m528.72,126.08v133.99l118.41,68.55c4.67,3.12,4.67,9.35,0,10.91l-140.22,81.02c-4.67,3.12-9.35,1.56-12.46,0l-140.22-81.02c-4.67-1.56-4.67-9.35,0-10.91l118.41-68.55V126.08l-303.59,174.17,330.08,191.96,330.29-192.54-300.69-173.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    "data-name": "path12",
    className: "i",
    d: "m432.12,700.98l-118.41-68.55-115.29,66.99,301.36,174.49-.66-381.71-330.08-191.96-.22,349.32v-1.56,1.56l115.29-66.99v-137.1c0-4.67,6.23-7.79,9.35-6.23l140.22,81.02c4.67,3.12,6.23,6.23,6.23,10.91v162.03c1.56,6.23-3.12,10.91-7.79,7.79Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnityLogo);
export default __webpack_public_path__ + "static/media/unity-logo.183d34651c5931a30cfd1afb4c032ce8.svg";
export { ForwardRef as ReactComponent };